export const NOTIFICATIONS_QUERY_KEY = 'notifications';
export const NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY = 'notificationsUnreadCount';

export const notificationKeys = {
  list: (page?: number) => [NOTIFICATIONS_QUERY_KEY, page] as const,
  unreadCount: () => [NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY] as const,
};
